module.exports = __webpack_public_path__ + "img/logo-full-white.614142f2.svg";